import React, { useRef } from 'react'
import PropTypes from 'prop-types'

import { Input, notification } from 'antd'
import * as Icons from '@ant-design/icons'

export const ClipboardCopy = ({ value }) => {
  const input = useRef()

  return (
    <Input
      readOnly
      value={value}
      suffix={<Icons.CopyFilled />}
      ref={input}
      onClick={() => {
        input.current.select()
        input.current.setSelectionRange(0, 99999)

        document.execCommand('copy')

        notification.success({ message: 'Copied API key to your clipboard' })
      }}
    />
  )
}

ClipboardCopy.propTypes = {
  value: PropTypes.string.isRequired
}
